import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Sort} from '@angular/material';

@Component({
    selector: 'users',
    styleUrls: ['./styles/users.component.css'],
    templateUrl: './templates/users.component.html',
})


export class SortTable {
    desserts: any = []  /*[
        {name: 'Frozen yogurt', calories: '159', fat: '6', carbs: '24', protein: '4'},
        {name: 'Ice cream sandwich', calories: '237', fat: '9', carbs: '37', protein: '4'},
        {name: 'Eclair', calories: '262', fat: '16', carbs: '24', protein: '6'},
        {name: 'Cupcake', calories: '305', fat: '4', carbs: '67', protein: '4'},
        {name: 'Gingerbread', calories: '356', fat: '16', carbs: '49', protein: '4'},
    ];*/

    sortedData: any;
    header_list: any;

    constructor() {
        this.sortedData = this.desserts.slice();
    }

    sortData(sort: Sort) {
        const data = this.desserts.slice();
        if (!sort.active || sort.direction == '') {
            this.sortedData = data;
            return;
        }

        this.sortedData = data.sort((a, b) => {
            let isAsc = sort.direction == 'asc';
            //switch (sort.active) {
            /*case 'name': return compare(a.name, b.name, isAsc);
            case 'calories': return compare(+a.calories, +b.calories, isAsc);
            case 'fat': return compare(+a.fat, +b.fat, isAsc);
            case 'carbs': return compare(+a.carbs, +b.carbs, isAsc);
            case 'protein': return compare(+a.protein, +b.protein, isAsc);*/
            for (let i = 0; i < this.header_list.length; i++) {

                if (sort.active == this.header_list[i]['value']) {
                    //console.log(this.header_list[i]);
                    if(this.header_list[i]['type'] == "number"){
                          return compare(+a[(this.header_list[i]['value'])], +b[(this.header_list[i]['value'])], isAsc);
                    }else{
                          return compare(a[(this.header_list[i]['value'])], b[(this.header_list[i]['value'])], isAsc);
                    }
                                 
                  
                }
            }
            return 0;
            //}
        });
    }

    GetSortData(): any {
        return this.sortedData;
    }
    
    GetDeData(): any {
        return this.desserts;
    }

    SetDataArray(data: any, header_list: any): void {
       
        this.desserts = data
        this.header_list = header_list;
         //console.log(this.header_list);
    }
}

function compare(a: any, b: any, isAsc: any) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}








// WEBPACK FOOTER //
// ./src/app/sort-table.component.ts